import { Modal } from '@odin-labs/components';
import React from 'react';
import { pluralize } from 'utils/pluralize';

export type CannotRemoveZoneModalProps = {
  /** The zone that could not be removed, and the entries that still face it; null when closed. */
  blocked: { zoneName: string; entryNames: string[] } | null;
  onClose: () => void;
};

/** Why a zone stays: entries still face it, and an entry cannot face nothing. */
export function CannotRemoveZoneModal({
  blocked,
  onClose,
}: CannotRemoveZoneModalProps): React.ReactElement {
  // The last reason stays on screen while the dialog animates closed.
  const [shown, setShown] = React.useState(blocked);
  React.useEffect(() => {
    if (blocked) setShown(blocked);
  }, [blocked]);
  const count = shown?.entryNames.length ?? 0;
  const them = count === 1 ? 'it' : 'them';
  return (
    <Modal
      open={blocked !== null}
      setOpen={(open) => !open && onClose()}
      title={`${shown?.zoneName || 'This zone'} cannot be removed`}
      text={
        shown
          ? `${pluralize(count, 'entry', 'entries')} still ${
              count === 1 ? 'faces' : 'face'
            } this zone: ${shown.entryNames.join(
              ', ',
            )}. Point ${them} at another zone, or remove ${them}, then remove the zone.`
          : ''
      }
      size="sm"
      actionButton={() => null}
      cancelText="Close"
      onCancel={onClose}
    />
  );
}
